import { render, staticRenderFns } from "./DepositAudit.vue?vue&type=template&id=56bbb96d&scoped=true&"
import script from "./DepositAudit.vue?vue&type=script&lang=js&"
export * from "./DepositAudit.vue?vue&type=script&lang=js&"
import style0 from "./DepositAudit.vue?vue&type=style&index=0&id=56bbb96d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbb96d",
  null
  
)

export default component.exports